/* eslint-disable jira/filename-case */
import { createContext, type Context as ReactContext } from 'react';
import { defaultRegistry, type StoreRegistry } from './store/registry.tsx';
import type { Store, ActionThunk, StoreInstance } from './types.tsx';

// calculateChangedBit param has been removed
// as it's no longer supported in React 18
export const Context: ReactContext<{
	globalRegistry: StoreRegistry;
	retrieveStore: <TState, TActions extends Record<string, ActionThunk<TState, TActions>>>(
		Store: Store<TState, TActions>,
	) => StoreInstance<TState, TActions>;
}> = createContext<{
	globalRegistry: StoreRegistry;
	retrieveStore: <TState, TActions extends Record<string, ActionThunk<TState, TActions>>>(
		Store: Store<TState, TActions>,
	) => StoreInstance<TState, TActions>;
}>({
	globalRegistry: defaultRegistry,
	retrieveStore: <TState, TActions extends Record<string, ActionThunk<TState, TActions>>>(
		Store: Store<TState, TActions>,
	): StoreInstance<TState, TActions> => defaultRegistry.getStore(Store),
});
